import { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom"
import { getTokenname, getStartsTokenname } from 'utils'
import { getShareDomain } from 'ts-utils/survey'
import { useMutation } from '@apollo/client'
import { UPDATE_SURVEY_ANALYSIS_USERS_MOVE_FIRST_QUESTION } from 'gql/survey_analysis_users'
import { withSurveyFetchSurveyNo, withSurveyFetchMboxWithRelation, withSurveyFetchData }  from 'hoc'
import { LangComponent } from 'component'
import IsIEContainer from './IsIE'
import CoverComponent, { Pos } from 'component/Survey/Modules/Cover'

const mode = 'live'

const Component = (props) => {
    const { levels, mbox, option, design, propsFetchData } = props
    const { mboxCover } = propsFetchData

    const { used, animation, src } = mboxCover

    const { survey_no, restart } = mbox
    const { first_question } = option

    const location = useLocation()
    const { pathname, search } = location

    const method = pathname.search('/re/') === 0 ? 'email' : 'ip'

    const tokenname = getTokenname(survey_no, method)
    const startsTokenname = getStartsTokenname(survey_no)

    const [ render, setRender ] = useState(false)
    

    const [ updateMoveFirstQuestion ] = useMutation(UPDATE_SURVEY_ANALYSIS_USERS_MOVE_FIRST_QUESTION, {
        onCompleted: (data) => {

            // 기존 데이터 시간 값 다 지우고, 완전 다시 시작하는 개념이다. (사용자 번호는 동일하다)
            if (data.updateSurveyAnalysisUsersMoveFirstQuestion === 2) {
                sessionStorage.removeItem(startsTokenname)    
            } 
            // 기존 데이터 유지 하고 새로운 응답자로 진행한다.
            else if (data.updateSurveyAnalysisUsersMoveFirstQuestion === 3) {
                localStorage.removeItem(tokenname)
                sessionStorage.removeItem(startsTokenname)
            }

            setRender(true)
        }
    })

    useEffect(() => {
        const listoDomain = getShareDomain(survey_no)
        const listoname = listoDomain.replace('https://', '')
        const hostname = window.location.hostname

        // 해당 설문 번호의 도메인으로 들어 온게 아니라면 랜딩으로 리다이렉션 시킨다.
        if (listoname !== hostname) {
            window.location.replace(process.env.REACT_APP_LANDING)
            return
        } 

        const token = localStorage.getItem(tokenname)

        // 토큰이 없으면 맨처음 접속한거니 바로 랜더링
        if (!token) {
            setRender(true)
            return
        }

        // first_question이 false이고, 완료우 재시작 restart가 false이면 그냥 바로 랜더링 하면된다.
        if (token && !first_question && !restart) {
            setRender(true)
            return
        }

        updateMoveFirstQuestion({
            variables: { survey_no, token, method, first_question, restart }
        })

    }, [pathname, search,survey_no, first_question, restart, tokenname, method, updateMoveFirstQuestion])

    if (!render) return null

    return (
        <>
        <LangComponent lang={mbox.lang}>
            <IsIEContainer {...props}/>
        </LangComponent>
        <CoverComponent levels={levels} pos={Pos.Live} brand={{ used, src, animation }} design={design}/>
        </>
    )
}

const fetchDataArgs = {
    mboxCover: true,
    _fetchPolicy: {
        mboxCover: true
    }
}

export default  withSurveyFetchSurveyNo()
                (withSurveyFetchMboxWithRelation({ mode, fetchPolicy: 'network-only' })(false)(withSurveyFetchData(mode)(fetchDataArgs)(false)(Component)))